import './Controls.css';

const ChevronLeft = () => (
  <svg viewBox="0 0 16 16" fill="none">
    <path d="M10 3L5 8l5 5" stroke="#97dd2f" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronRight = () => (
  <svg viewBox="0 0 16 16" fill="none">
    <path d="M6 3l5 5-5 5" stroke="#97dd2f" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Controls = ({ current, total, onPrev, onNext, onDotClick }) => {
  return (
    <div className="controls">
      <div className="controls__dots">
        {Array.from({ length: total }).map((_, i) => (
          <button
            key={i}
            className={`controls__dot${i === current ? ' controls__dot--active' : ''}`}
            onClick={() => onDotClick(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>

      <div className="controls__arrows">
        <button
          className="controls__arrow"
          onClick={onPrev}
          aria-label="Previous slide"
        >
          <ChevronLeft />
        </button>
        <button
          className="controls__arrow"
          onClick={onNext}
          aria-label="Next slide"
        >
          <ChevronRight />
        </button>
      </div>
    </div>
  );
};

export default Controls;
